export const ENGLISH_TRANSLATIONS = {
  text: {
    web_title: 'Smartz DASHBOARD',
    authentication: 'Authentication',
    username: 'Username',
    password: 'Password',
    sign_in: 'Sign In',
    username_required: 'Username is required',
    password_required: 'Password is required',
    invalid_credential: 'Incorrect username or password',
    forgot_password: 'Forgot Password',
    logout: 'Logout',
    languages: 'Languages',
    dashboard: 'DASHBOARD',
    products: 'PRODUCTS',
    pods: 'PODS',
    reports: 'REPORTS',
    this_website_uses_cookies: 'This website uses cookies',
    uses_cookie_desc:
      'We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information  about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you’ve provided to them or that they’ve collected from your use of their services.',
    use_necessary_cookie_only: 'Use necessary cookies only',
    allow_selection: 'Allow selection',
    allow_all_cookies: 'Allow all cookies',
    hide_details: 'Hide Details',
    necessary: 'Necessary',
    preferences: 'Preferences',
    statistics: 'Statistics',
    marketing: 'Marketing',
    unclassified: 'Unclassified',
    cookie_declaration: 'Cookie declaration',
    about_cookies: 'About cookies',
    necessary_desc:
      'Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.',
    preferences_desc:
      'Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.',
    statistic_desc:
      'Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.',
    marketing_desc:
      'Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the  publishers and third party advertisers.',
    unclassified_desc:
      'Unclassified cookies are cookies that we are in the process of classifying, together with the providers of individual cookies.',
    about_cookies_desc:
      "Cookies are small text files that can be used by websites to make a user's experience more efficient. The law states that we can store cookies on your device if they are strictly necessary for the operation of this site. For all other types of cookies we need your permission. This site uses different types of cookies. Some cookies are placed by third party services that appear on our pages.",
    name: 'Name',
    provider: 'Provider',
    purpose: 'Purpose',
    expiry: 'Expiry',
    type: 'Type',
    frequently_asked_questions: 'Frequently Asked Questions',
    information_for_use: 'Information for Use',
    data_privacy: 'Data Privacy',
    eula: 'EULA',
    about: 'About',
    settings: 'Settings',
    my_account: 'My Account',
    version: 'version',
    support: 'support',
    close: 'Close',
    copyright: 'Copyright (C) 2020 Simavita Pty Ltd. All Rights Reserved',
    manufacturers: 'manufacturers',
    characterisation: 'characterisation',
    address: 'address',
    contact: 'contact',
    action: 'action',
    view: 'view',
    edit: 'edit',
    add: 'add',
    add_manufacturer: 'Add Manufacturer',
    edit_manufacturer: 'Edit Manufacturer',
    created: 'created',
    details: 'details',
    other: 'other',
    active: 'Active',
    save: 'save',
    product_description: 'Product Description',
    general_product_description: 'general product description',
    product_characteristics: 'Product Characteristics',
    product_characterise_properties: 'product characterised properties',
    description: 'Description',
    working_capacity: 'Working Capacity',
    add_product: 'Add Product',
    edit_product: 'Edit Product',
    hardware: 'Hardware',
    position: 'Position',
    constant: 'Constant',
    yellow_threshold: 'Yellow Threshold',
    red_threshold: 'Red Threshold',
    firmware_version: 'Firmware Version',
    hardware_version: 'Hardware Version',
    thresholds: 'Thresholds',
    yellow: 'Yellow',
    red: 'Red',
    product_characterisation: 'Product Characterisation',
    run: 'Run',
    characterisation_run: 'characterisation run',
    analyse_runs: 'Analyse Runs',
    analyse_runs_desc: 'analyse and create product characteristics',
    product_characterisation_run: 'Product Characterisation Run',
    tester: 'Tester',
    pod: 'Pod',
    weight: 'Weight',
    incomplete_run: 'Incomplete Run',
    continue: 'continue',
    start_new: 'start new',
    started: 'started',
    finish: 'finish',
    entries: 'Entries',
    time: 'Time',
    void: 'Void',
    comment: 'Comment',
    add_entry: 'ADD ENTRY',
    pod_data: 'Pod Data',
    sensor: 'sensor',
    select: 'Select',
    export_data: 'Export Data',
    date: 'Date',
    comments_for: 'Comments for',
    pad_characterization_detail_for: 'Pad Characterization Detail for',
    desc: 'Desc',
    volume: 'Volume',
    median: 'Median',
    agg: 'Agg',
    new_agg: 'New Agg',
    sensor_value: 'sensor value',
    sensor_value_agg: 'sensor value agg',
    select_run_to_analyse: 'Select Run to Analyse',
    product_characterisation_analysis: 'Product Characterisation Analysis',
    chart_data: 'chart data',
    calibration: 'calibration',
    capacitance_readings: 'Capacitance Readings',
    capacitance_sensor_readings: 'capacitance sensor readings',
    connection_status: 'Connection Status',
    pad_connections: 'pad connections',
    battery_levels: 'Battery Levels',
    battery_level_and_status: 'Battery level and status',
    accelerometer_readings: 'Accelerometer Readings',
    ax_ay_az: 'Ax, Ay, Az and position, falls status',
    chart_pod_capacitance_readings: 'Chart Pod Capacitance Readings',
    y_axis_max: 'Y axis max',
    auto_refresh: 'auto-refresh',
    apply: 'Apply',
    latest_time: 'Latest time',
    countdown_to_median: 'Countdown to Median',
    recent_data_for: 'Recent data for',
    chart_pod_connection_status: 'Chart Pod Connection Status',
    chart_pod_battery_level: 'Chart Pod Battery Level',
    chart_pod_accelerometer: 'Chart Pod Accelerometer',
    export_pod_data: 'Export Pod Data',
    raw_data: 'Raw Data',
    export: 'Export',
    from_date: 'from date',
    to_date: 'to date',
    utc_offset: 'UTC offset',
    pod_calibration: 'Pod Calibration',
    calibrattion_status: 'Calibrattion Status',
    capacitive: 'Capacitive',
    accelerometer: 'Accelerometer',
    calibration_data: 'Calibration Data',
    capacitive_sensor: 'Capacitive Sensor',
    battery: 'Battery',
    thermistor: 'Thermistor',
    spo2: 'SPO2',
    blood_oxygen_saturation: 'Blood Oxygen Saturation',
    chart_pod_spo2_readings: 'Chart Pod SPO2 Readings',
    live: 'LIVE',
    chart_date: 'Chart Date',
    please_select: 'Please select',
    product: 'product',
    tester_required: 'tester is required',
    product_required: 'product is required',
    pod_required: 'pod is required',
    position_required: 'position is required',
    weight_required: 'weight is required',
    lying_left: 'Lying Left',
    lying_right: 'Lying Right',
    lying_back: 'Lying Back',
    lying_front: 'Lying Front',
    sit: 'Sit',
    stand: 'Stand',
    void_required: 'void is required',
    comment_required: 'comment is required',
    please_select_a_product: 'Please select a product',
    filter_by_group_or_users: 'filter by group or users',
    manage: 'MANAGE',
    users: 'Users',
    roles: 'Roles',
    user_accounts: 'USER ACCOUNTS',
    role: 'Role',
    status: 'Status',
    disabled: 'Disabled',
    add_user_account: 'ADD USER ACCOUNT',
    edit_user_account: 'EDIT USER ACCOUNT',
    fullname: 'Fullname',
    phone: 'Phone',
    email: 'Email',
    role_required: 'Role is required',
    enter_correct_email: 'Please enter the correct email address',
    email_required: 'Email is required',
    add_role: 'ADD ROLE',
    edit_role: 'EDIT ROLE',
    role_list: 'Role List',
    role_name: 'Role Name',
    role_permissions: 'Role Permissions',
    level_1_module: 'Level 1 module',
    level_2_module: 'Level 2 module',
    permissions: 'Permissions',
    cancel: 'Cancel',
    filter_by_role_name: 'filter by role name',
    chart_time: 'Chart Time',
    vital_signs: 'Vital Signs',
    heart_rate: 'Heart Rate',
    body_temperature: 'Body Temperature',
    pod_capacitance: 'pod capacitance',
    pod_accel: 'pod accel',
    pod_status: 'pod status',
    name_required: 'Name is required',
    address_required: 'Address is required',
    contact_required: 'Contact is required',
    id_required: 'ID is required',
    description_required: 'Description is required',
    working_capacity_required: 'Working Capacity is required',
    constant_a_required: 'Constant A is required',
    constant_b_required: 'Constant B is required',
    constant_c_required: 'Constant C is required',
    constant_d_required: 'Constant D is required',
    yellow_threshold_required: 'Yellow Threshold is required',
    red_threshold_required: 'Red Threshold is required',
    firmware_version_required: 'Firmware Version is required',
    hardware_version_required: 'Hardware Version is required',
    group: 'Group',
    reset_password: 'Reset Password',
    new_password: 'New Password',
    confirm_password: 'Confirm Password',
    please_enter_password: 'Please enter password',
    please_enter_password_again: 'Please enter password again',
    password_inconsistent: 'The password is inconsistent',
    saved_successfully: 'Saved Successfully',
    s1_offset_required: 'S1_Offset is required',
    s2_offset_required: 'S2_Offset is required',
    s1_gain_required: 'S1_Gain is required',
    s2_gain_required: 'S2_Gain is required',
    bat_offset_required: 'Bat_Offset is required',
    temp_offset_required: 'Temp_Offset is required',
    acc_x_offset_required: 'Acc_XOffset is required',
    acc_x_gain_required: 'Acc_XGain is required',
    acc_y_offset_required: 'Acc_YOffset is required',
    acc_y_gain_required: 'Acc_YGain is required',
    acc_z_offset_required: 'Acc_ZOffset is required',
    acc_z_gain_required: 'Acc_ZGain is required',
    edit_roles: 'Edit Roles',
    available_roles: 'Available roles',
    assigned_roles: 'Assigned roles',
    delete: 'delete',
    you_able_to_delete_data: "You're about to delete",
    delete_role_confirm:
      'Please keep in mind that deleting roles is permanent.',
    aggregate: 'aggregate',
    magnitude: 'magnitude',
    connection: 'Connection',
    fall: 'Fall',
    tag_data: 'Tag Data',
    notes: 'Notes',
    add_tag: 'Add Tag',
    'Run away line': 'Run away line',
    'Non responsive line': 'Non responsive line',
    Divergence: 'Divergence',
    'Disconnected line': 'Disconnected line',
    'Saturated readings': 'Saturated readings',
    Unexplained: 'Unexplained',
    please_enter: 'Please enter',
    find_data: 'Find Data',
    find_tagged_data: 'Find Tagged Data',
    find_data_with_tag: 'Find data with tag',
    find: 'Find',
    found: 'Found',
    mac_address: 'MAC Address',
    tag_timestamp: 'Tag Timestamp',
    tagged_by: 'Tagged By',
    tag: 'Tag',
    period: 'Period',
    clear_selected: 'Clear selected',
    code: 'Code',
    manufacturer_code_required: 'Manufacturer code is required',
    failed: 'Failed',
    product_number: 'Product Number',
    manufacturer: 'Manufacturer',
    product_number_required: 'Product Number is required',
    manufacturer_required: 'Manufacturer is required',
    urine: 'Urine',
    max_capacity: 'Max Capacity',
    urine_details: 'Urine Details',
    urine_thresholds: 'Urine Thresholds',
    max_capacity_required: 'Max capacity is required',
    pod_id_required: 'Pod ID is required',
    choose_a_report: 'Choose a report',
    select_date_range: 'Select date range',
    start_time: 'start time',
    end_time: 'end time',
    select_groups_to_collate: 'Select group(s) to collate',
    all_groups: 'All groups',
    group_include: 'Group to include in report generation',
    export_report: 'Export Report',
    export_csv: 'Export CSV',
    //translate permission list
    Dashboard: 'Dashboard',
    'Pod Accel': 'Pod Accel',
    'Pod Capacitance': 'Pod Capacitance',
    Products: 'Products',
    Manufacturers: 'Manufacturers',
    'Product Description': 'Product Description',
    'Product Characteristics': 'Product Characteristics',
    Run: 'Run',
    'Analyse Runs': 'Analyse Runs',
    Pods: 'Pods',
    'Capacitance Readings Chart': 'Capacitance Readings Chart',
    'Connection Status Chart': 'Connection Status Chart',
    'Battery Levels Chart': 'Battery Levels Chart',
    'Accelerometer Readings Chart': 'Accelerometer Readings Chart',
    'SPO2 Chart': 'SPO2 Chart',
    'Export Pod Data': 'Export Pod Data',
    Calibration: 'Calibration',
    Manage: 'Manage',
    Users: 'Users',
    Roles: 'Roles',
    View: 'View',
    Add: 'Add',
    Edit: 'Edit',
    Delete: 'Delete',
    Reports: 'Reports',
    'Export CSV': 'Export CSV',
    Export: 'Export',
    'Find Data': 'Find Data',
    'Reset Password': 'Reset Password',
    //end translate permission list
    ago: 'ago',
    value: 'Value',
    min: 'Min',
    max: 'Max',
    are_you_sure: 'Are you sure',
    whether_continue:
      'You will add an entry, please confirm whether to continue'
  },
  country: 'Australia',
  language: 'english',
  abb_name: 'en'
}
